var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2H1.5C0.6675 2 0.00749999 2.6675 0.00749999 3.5L0 12.5C0 13.3325 0.6675 14 1.5 14H13.5C14.3325 14 15 13.3325 15 12.5V3.5C15 2.6675 14.3325 2 13.5 2ZM13.5 12.5H1.5V8H13.5V12.5ZM13.5 5H1.5V3.5H13.5V5Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPayment);
export default __webpack_public_path__ + "static/media/ic-payment.fbdede2ebdb101e37f0fc943ae6219a0.svg";
export { ForwardRef as ReactComponent };